import { useState, useEffect } from "react"
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ResponsiveAppBar from "../ResponsiveAppBar"
import ResponsiveFooter from "../ResponsiveFooter";

import { Link } from 'react-router-dom';
import { Card, CardContent, Grid, Paper, Typography, TextField, Button } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import * as React from 'react';

import * as constants from "../constants.js"


const ChangeEMail = () => {
    const [user, setUser] = useState('');
    const [email, setEmail] = useState('');
    const [newEmail, setNewEmail] = useState('');
    const [isEmailValid, setEmailValid] = useState(false);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('info');
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
          try {
            const resp = await axios.create({
                withCredentials: true,
              }).get("//" + constants.BASE_URL + "/@me");
            setUser(resp.data);
            setEmail(resp.data.email);
          } catch (error) {
            navigate('/login');
          }
        })();
      }, []);

    const cardStyle = {
      borderRadius: '10px', // Adjust the value to control the roundness of the corners
      // You can also add other styles like backgroundColor, boxShadow, etc.
    };

    const isValidEmail = (validEmail) => {
        // You can use a regular expression or a more robust email validation method here
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(validEmail);
    };

    const handleEmailChangeInput = (e) => {
        setNewEmail(e.target.value)
        setEmailValid(true);
        if (newEmail === email || !isValidEmail(newEmail)) {
            setEmailValid(false);
            return;
        }
    };

    const handleSnackbarClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpen(false);
    };

    const handleEmailChangeSubmit = async (e) => {
        e.preventDefault()
        try{
          const resp = await axios.create({
              withCredentials: true,
          }).post("//" + constants.BASE_URL + "/change_user_mail", {
            newEmail
          });
          setMessage(resp.data.success);
          setSeverity('success');
          setOpen(true);
        }
        catch(error){
            if (error.response) {
              setMessage(error.response.data.error);
            } else if (error.request) {
              setMessage('The request was made but no response was received');
            } else {
              setMessage('An error occurred');
            }
            setSeverity('error');
            setOpen(true);
        }
    };

     
    return ( 
        <div className="home">
            <ResponsiveAppBar />
            <div className="body-content">
              <br></br>
              <h2>E-mail ändern</h2>
              <br></br>

          <Card style={cardStyle}>
            <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Aktuelle E-mail"
              variant="outlined"
              fullWidth
              value={email}
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Neue E-mail"
              variant="outlined"
              fullWidth
              value={newEmail}
              onChange={handleEmailChangeInput}
              error={!isEmailValid}
              helperText={!isEmailValid && "Die angegebene E-mail ist nicht zulässig."}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleEmailChangeSubmit}
              disabled={!isEmailValid || newEmail === email}
            >
              E-mail ändern
            </Button>
          </Grid>
        </Grid>
            </CardContent>
          </Card>
          <br></br>
          <Button
              variant="contained"
              color="grey"
              onClick={() => {navigate('/user/preferences');}}
            >
              Zurück
            </Button>

            <Snackbar open={open} autoHideDuration={6000} onClose={handleSnackbarClose}>
              <MuiAlert elevation={6} variant="filled" onClose={handleSnackbarClose} severity={severity}>
                {message}
              </MuiAlert>
            </Snackbar>

          </div>
          <ResponsiveFooter />
        </div>
     );
}
 
export default ChangeEMail;